  <div class="row">
       <div class="col" style="margin: 15vh 15vw 1vh; color: #777; font-size: 3vh; text-align: center;">
           Oops! It seems you do not have   <br>
           permission to Access this page  :)
       </div>
   </div>
   <div class="row">
       <div class="col" style="margin: 1vh 15vw 15vh; text-align: center;">
           <button class="btn btn-primary" style="width: 30vw;"  (click)="goToHome()">Go to Home</button>
       </div>
   </div>